import React from "react";

const PlaceholderImageCircleIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="16" fill="#ECECEF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.2041 22.9893L21 23H11L10.7959 22.9893C9.85435 22.8938 9.1062 22.1457 9.01074 21.2041L9 21V11C9 9.96435 9.78722 9.113 10.7959 9.01074L11 9H21L21.2041 9.01074C22.2128 9.113 23 9.96435 23 11V21L22.9893 21.2041C22.8938 22.1457 22.1457 22.8938 21.2041 22.9893ZM11 21.5H21C21.2761 21.5 21.5 21.2761 21.5 21V11C21.5 10.7239 21.2761 10.5 21 10.5H11C10.7239 10.5 10.5 10.7239 10.5 11V21C10.5 21.2761 10.7239 21.5 11 21.5ZM20 18.8571L17.5 16L15.0244 18.8293L13.5 17L12 18.8V20H20V18.8571ZM14.5 16C15.3284 16 16 15.3284 16 14.5C16 13.6716 15.3284 13 14.5 13C13.6716 13 13 13.6716 13 14.5C13 15.3284 13.6716 16 14.5 16Z"
      fill="#A4A3A8"
    />
  </svg>
);

export default PlaceholderImageCircleIcon;
